<template>
	<div class="progress">
		<div
			role="progressbar"
			aria-valuemin="0"
			aria-valuemax="100"
			class="progress-bar"
		>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Progressbar',
	props: {
		progress: {
			type: Number,
			required: true,
		},
	},
	data: function() {
		return {
			progressbar: {},
		};
	},
	watch: {
		progress: function() {
			this.init();
		},
	},
	mounted: function() {
		this.$nextTick(() => {
			this.init();
		});
	},
	methods: {
		init() {
			this.progressbar = document.getElementsByClassName('progress-bar')[0];
			this.progressbar.style.width = this.progress + '%';
		},
	},
};
</script>

<style>
.progress {
  background-color: #eceeef;
  border-radius: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  font-size: 0.75rem;
  height: 1rem;
  line-height: 1rem;
  overflow: hidden;
  text-align: center;
}

.progress-bar {
  transition: all 0.5s;
}
.progress-bar {
  width: 0px;
  color: transparent !important;
  height: 100%;
  background-color: #64b5d9 !important;
}
</style>
